import { render, staticRenderFns } from "./More.vue?vue&type=template&id=39318618&scoped=true&"
import script from "./More.vue?vue&type=script&lang=ts&"
export * from "./More.vue?vue&type=script&lang=ts&"
import style0 from "./more.scss?vue&type=style&index=0&id=39318618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39318618",
  null
  
)

export default component.exports